import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum PropertyManagementSecurityRight {
    CanAccess = 41000
}

export class PropertyManagementSecurityModule extends BaseSecurityModule<PropertyManagementSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.PropertyManagement,
            [
                { _id: PropertyManagementSecurityRight.CanAccess, name: 'Access', basic: true },
            ] as SecurityRight<PropertyManagementSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}